// Whitelist dozwolonych domen do redirect
// Dodaj nowe domeny tutaj:
const ALLOWED_REDIRECT_DOMAINS = [
  'content.bergregions.pl',
  'dev.content.bergregions.pl',
  'daa.content.bergregions.pl',
  'wawel.content.bergregions.pl',
  'localhost:3000',
];

export const isAllowedRedirectDomain = (domain) => {
  if (!domain) return false;
  return ALLOWED_REDIRECT_DOMAINS.includes(domain);
};

const CLIENT_NAMES = {
  'content.bergregions.pl': 'Berg Content Management System',
  'dev.content.bergregions.pl': 'Berg Content Management System (DEV)',
  'daa.content.bergregions.pl': 'Berg Content Management System (DAA)',
  'wawel.content.bergregions.pl': 'Berg Content Management System (Wawel)',
  'localhost:3000': 'Local Development',
};

export const getClientName = (redirectToClient) => {
  return CLIENT_NAMES[redirectToClient] || '';
};